export const teamMembers = [
  {
    id: 1,
    name: "Pasqual Vidal Ferrer",
    role: "Asesor Fiscal",
    description: "",
    specialties: ["Fiscalidad empresarial", "IRPF y Sociedades", "PAC y ayudas agrarias", "Planificación fiscal"],
    image: "https://storage.readdy-site.link/project_files/db85668d-0973-4f5a-ac63-8b47d247ab38/cb81e2b9-c94f-4037-a957-2be9af3f1eb9_Pasqual-Vidal-Ferrer.png?v=efa92c2437edb26c5b85851d36d4cd0a",
    linkedin: "#",
  },
  {
    id: 2,
    name: "Anna Vidal Ferrer",
    role: "Asesora Laboral",
    description: "",
    specialties: ["Nóminas", "Seguros Sociales", "Gestión Laboral", "Conciliaciones bancarias"],
    image: "https://storage.readdy-site.link/project_files/db85668d-0973-4f5a-ac63-8b47d247ab38/ebdcf704-343e-4355-bc5e-f3b64e76d45d_Anna-Vidal-Ferrer.png?v=39b0d1f9b4bdd55b79555b0bd8389133",
    linkedin: "#",
  },
  {
    id: 3,
    name: "Marilo Ferrer Bay",
    role: "Responsable de Seguros",
    description: "",
    specialties: ["Seguros agrícolas", "Seguros de empresa", "Vida y salud", "Seguros multirriesgo"],
    image: "https://storage.readdy-site.link/project_files/db85668d-0973-4f5a-ac63-8b47d247ab38/98c58b97-d4df-49bd-921a-1634c2b0a56c_Marilo-Ferrer-Bay.png?v=c9ee71734bef37513bc16dae81216a43",
    linkedin: "#",
  },
];
